import { render, staticRenderFns } from "./QuickActionsWidget.vue?vue&type=template&id=c089a75a&scoped=true"
import script from "./QuickActionsWidget.vue?vue&type=script&lang=js"
export * from "./QuickActionsWidget.vue?vue&type=script&lang=js"
import style0 from "./QuickActionsWidget.vue?vue&type=style&index=0&id=c089a75a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c089a75a",
  null
  
)

export default component.exports